import React, { useState, useEffect } from 'react'
import { getSolicitud } from '../../service/apiBackEnd.js';
import { Container, Row, Col } from 'react-bootstrap';
import styles from '../index.module.css';

const Solicitud = () => {
    const [allData, setAllData] = useState([]);
    const [enrichedData, setEnrichedData] = useState([]); // Nuevo estado para los datos enriquecidos

    useEffect(() => {
        const fetchData = async () => {
            const res = await getSolicitud();
            console.log("DATA", res);
            setAllData(res);
        };
        fetchData();
    }, []);

    useEffect(() => {
        const getMediaUrl = async (mediaId) => {
            try {
                const response = await fetch(`http://epas.test.di.dgi.loc/wp-json/wp/v2/media/${mediaId}`);
                const mediaData = await response.json();
                return mediaData.source_url;
            } catch (error) {
                console.error("Error fetching media:", error);
                return null;
            }
        };

        const fetchMediaUrls = async () => {
            const updatedData = await Promise.all(
                allData.map(async (elem) => {
                    const archivoUrl = elem.acf?.adjuntar_archivo
                        ? await getMediaUrl(elem.acf.adjuntar_archivo)
                        : null;
                    const archivoUrl2 = elem.acf?.adjuntar_archivo_2
                        ? await getMediaUrl(elem.acf.adjuntar_archivo_2)
                        : null;

                    return { ...elem, archivoUrl, archivoUrl2 };
                })
            );
            setEnrichedData(updatedData); // Guardar los datos enriquecidos por separado
        };

        if (allData.length > 0 && enrichedData.length === 0) { // Solo si aún no se han enriquecido los datos
            fetchMediaUrls();
        }
    }, [allData, enrichedData]);

    console.log("DATAAAA", enrichedData);

    return (
        <Container>
            <Row>
                <h1 className="mt-5 mb-4">Solicitud Constitución Operador</h1>
                {enrichedData.map((item, index) => {
                    console.log("ITEM", item);
                    return (
                        <Col key={index} className='mb-4'>

                            <div
                                dangerouslySetInnerHTML={{
                                    __html: item.acf.detalle,
                                }}
                            />
                            <hr></hr>

                            {item.archivoUrl && (
                                <a href={item.archivoUrl} target="_blank" rel="noopener noreferrer" download className={styles.btnDescarga}>
                                    Formulario Constitución/Aprobación Nuevo Operador
                                </a>
                            )}

                        </Col>
                    )
                })}

            </Row>
        </Container>
    );
};
export default Solicitud;
